"use client";
import React from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { GA4DataLayer } from "@packages/lib/utlils/helper-function";
import { GAConstants } from "@packages/shared-components/services/constants";

interface OpenDaysTypeTabsProps {
  commonGAAttrs?: any;
}

const OpenDaysTypeTabs = ({ commonGAAttrs }: OpenDaysTypeTabsProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const dateParam = searchParams?.get("date");
  
  // If date=virtual_tour, set to anytime tab, otherwise check type param
  const currentType = dateParam === "virtual_tour" 
    ? "anytime" 
    : searchParams?.get("type") || "live";

  const handleTabClick = (type: string) => {
    const tabName = type === "live" ? "live_open_days" : "anytime_open_days";
    const destinationPageName = type === "live" ? "opendays_landing" : "opendays_search";
    
    // Set destination page_name before navigation so GA4DataLayer picks it up correctly
    localStorage.setItem("gaPageName", destinationPageName);
    
    GA4DataLayer({
      event: GAConstants.track_event,
      event_name: "open_day_type_filter",
      click_text: tabName,
    });

    if (type === "live") {
      // When switching to live tab, clear all filters
      router.push("/open-days/");
    } else {
      // When switching to anytime tab, clear all filters and set date=virtual_tour
      router.push("/open-days/search/?date=virtual_tour");
    }
  };

  return (
    <div className="border-b border-grey-200 bg-white px-[16px] md:px-[20px] xl:px-0">
      <div className="max-w-container mx-auto">
        <div className="flex gap-[8px] py-[12px]">
          <button
            type="button"
            onClick={() => handleTabClick("live")}
            className={`px-[12px] py-[8px] rounded-[20px] font-inter text-[14px] font-semibold leading-[21px] text-center transition-colors ${
              currentType === "live"
                ? "bg-[#333333] text-white"
                : "bg-white text-grey300 border border-[#5C656E]"
            }`}
          >
            Live open days
          </button>
          <button
            type="button"
            onClick={() => handleTabClick("anytime")}
            className={`px-[12px] py-[8px] rounded-[20px] font-inter text-[14px] font-semibold leading-[21px] text-center transition-colors ${
              currentType === "anytime"
                ? "bg-[#333333] text-white"
                : "bg-white text-grey300 border border-[#5C656E]"
            }`}
          >
            Anytime open days
          </button>
        </div>
      </div>
    </div>
  );
};

export default OpenDaysTypeTabs;
